import React, { useState } from "react"
import Icon from "../../../components/AppIcon"
import Input from "../../../components/ui/Input"
import Button from "../../../components/ui/Button"
import QuestionListEditor from "./QuestionListEditor"
import { generateLocalId } from "../../../utils/courseHelpers"

const createEmptyCapstone = () => ({
  id: generateLocalId(),
  title: "Capstone Exam",
  passingScore: 80,
  pointsReward: 50,
  questions: [],
})

const CapstoneEditor = ({ capstone, onChange, certificationEnabled }) => {
  const [expanded, setExpanded] = useState(!!capstone)

  return (
    <div className="bg-card border border-border rounded-xl p-6 space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-semibold text-foreground uppercase tracking-wide flex items-center gap-2">
          <Icon name="Trophy" size={16} /> Capstone Exam
        </h2>
        {capstone && (
          <Button variant="ghost" size="sm" onClick={() => setExpanded((e) => !e)}>
            {expanded ? "Collapse" : "Expand"}
          </Button>
        )}
      </div>

      {!capstone ? (
        <Button
          variant="outline"
          iconName="Plus"
          iconPosition="left"
          onClick={() => { onChange(createEmptyCapstone()); setExpanded(true) }}
        >
          Add a Capstone Exam
        </Button>
      ) : (
        <>
          {certificationEnabled === false && (
            <p className="text-xs text-warning bg-warning/10 border border-warning/20 rounded-lg p-3">
              Certification isn't enabled for this course yet — passing the capstone won't issue certified status until you enable it in Course Details.
            </p>
          )}

          {expanded && (
            <div className="space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                <Input
                  label="Exam Title"
                  value={capstone?.title}
                  onChange={(e) => onChange({ ...capstone, title: e?.target?.value })}
                />
                <Input
                  label="Passing Score (%)"
                  type="number"
                  value={capstone?.passingScore}
                  onChange={(e) => onChange({ ...capstone, passingScore: Number(e?.target?.value) || 0 })}
                />
                <Input
                  label="Points Reward"
                  type="number"
                  value={capstone?.pointsReward}
                  onChange={(e) => onChange({ ...capstone, pointsReward: Number(e?.target?.value) || 0 })}
                />
              </div>

              <QuestionListEditor
                questions={capstone?.questions || []}
                onChange={(questions) => onChange({ ...capstone, questions })}
              />

              <Button
                variant="ghost"
                size="sm"
                iconName="Trash2"
                iconPosition="left"
                className="text-destructive"
                onClick={() => {
                  if (window.confirm("Remove the capstone exam entirely?")) onChange(null)
                }}
              >
                Remove Capstone
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default CapstoneEditor
